/**
 * The bell's list: server-backed leave decisions and on-device notices
 * (`data/device_notifications.ts`) in one newest-first sequence. Pure, so the
 * ordering is testable without rendering the dropdown.
 */
import type { DeviceNotification } from '../../data/device_notifications.js';
import type { EmployeeNotification } from '../../data/use_employee_notifications.js';

export type BellItem =
  | { kind: 'server'; notice: EmployeeNotification }
  | { kind: 'device'; notice: DeviceNotification };

function time_of(item: BellItem): number {
  const ms = new Date(item.notice.created_at).getTime();
  // An unparseable timestamp sorts last rather than poisoning the sort.
  return Number.isNaN(ms) ? Number.NEGATIVE_INFINITY : ms;
}

export function merge_bell_items(
  server: readonly EmployeeNotification[],
  device: readonly DeviceNotification[],
): BellItem[] {
  const items: BellItem[] = [
    ...server.map((notice): BellItem => ({ kind: 'server', notice })),
    ...device.map((notice): BellItem => ({ kind: 'device', notice })),
  ];
  return items.sort((a, b) => time_of(b) - time_of(a));
}
